import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetVendorId } from "../../hooks/global/User";
import ModuleReportSelector from "./ModuleReportSelector";
import { useGetCompanyModule, useGetModules } from "../../hooks/groups/Modules";
import LoadingSpinner from "../global/LoadingSpinner";
import ModuleReportStatistic from "./ModuleReportStatistic";
import ReportTableV8 from "./ReportTableV8";


function ModuleReport() {
  const { t, i18n } = useTranslation();
  const vendorId = useGetVendorId();


  const [currentModule, setCurrentModule] = useState(null);
  const [baseDate, setBaseDate] = useState(null);
  const [compareDate, setCompareDate] = useState(null);

  const { data: modules, isLoading: modulesIsLoading, isError: moduleIsError, isFetching:moduleIsFetching } = useGetModules(true);
  const { data: company, isLoading: companyIsLoading, isError: companyIsError, isFetching:companyIsFetching } = useGetCompanyModule(true);


  const handleUpdate = (e) => {
    setCurrentModule(e.currentModule);
    setBaseDate(e.baseDate);

    setCompareDate(e.compareDate);
  }



  if (modulesIsLoading || companyIsLoading ) return <LoadingSpinner /> //|| moduleIsFetching || companyIsFetching
  if (moduleIsError || companyIsError) return 'An error has occurred: ' + moduleIsError.message;

  return (
    <div id="adminReport" style={{backgroundColor:'#eee'}}>
      <Container fluid className="adminReportWide">
        <ModuleReportSelector modules={modules} company={company} onUpdated={handleUpdate} />
        <ModuleReportStatistic module={currentModule} baseDate={baseDate} compareDate={compareDate} />
      </Container>
      <div className="px-4" style={{backgroundColor:'#fff'}}>
            <ReportTableV8 module={currentModule} baseDate={baseDate} compareDate={compareDate} /> 
      </div>
    </div>
  );
}

export default ModuleReport;
